module.exports = __webpack_public_path__ + "img/galo.aad21512.png";